<div class="pw-backdrop" (click)="dismiss()">
  <div
    class="pw-sheet"
    (click)="$event.stopPropagation()"
    role="dialog"
    aria-modal="true"
  >
    <button
      type="button"
      class="pw-close"
      (click)="dismiss()"
      [attr.aria-label]="'resultDetail.close' | translate"
    >
      &times;
    </button>

    <div class="pw-scroll">
      <!-- Header -->
      <div class="pw-head">
        <h1 class="pw-title">
          {{ (variant === 'A' ? 'paywall.titleA' : 'paywall.titleB') | translate }}
        </h1>
        <p class="pw-sub">
          {{ (variant === 'A' ? 'paywall.subA' : 'paywall.subB') | translate }}
        </p>
        <div class="pw-rule"></div>
      </div>

      <!-- Variant A: free-continue path (never blocking) -->
      <div class="pw-free" *ngIf="variant === 'A'">
        <p class="pw-recap">{{ 'paywall.recapA' | translate }}</p>
        <button type="button" class="pw-cta pw-free-cta" (click)="dismiss()">
          {{ 'paywall.freeCta' | translate }}
        </button>
      </div>

      <div class="pw-divider" *ngIf="variant === 'A'">
        <span>{{ 'paywall.orDivider' | translate }}</span>
      </div>

      <!-- Loading prices -->
      <div class="pw-loading" *ngIf="!pricesLoaded">
        <div class="pw-spinner" aria-label="loading"></div>
      </div>

      <!-- Plan cards -->
      <div class="pw-cards" *ngIf="pricesLoaded">
        <!-- HERO: one-time 30-day pass -->
        <div class="pw-card hero" *ngIf="!storeMode || storeProducts.onetime">
          <div class="pw-badge">{{ 'paywall.badge' | translate }}</div>
          <div class="pw-kicker">{{ 'payment.oneTime.tag' | translate }}</div>
          <div class="pw-price">
            {{ oneTimeDisplay }}
            <span class="pw-once">{{ 'paywall.once' | translate }}</span>
          </div>
          <ul class="pw-features">
            <li>{{ 'payment.oneTime.feature1' | translate }}</li>
          </ul>
          <button
            type="button"
            class="pw-cta primary"
            (click)="storeMode ? storeBuy('onetime') : selectOneTime()"
            [disabled]="isProcessing"
          >
            {{
              processingPlanId === 'onetime'
                ? ('payment.processing' | translate)
                : ('payment.oneTime.button' | translate)
            }}
          </button>
          <div class="pw-clarity">
            {{ 'payment.oneTime.billing' | translate }}<br />{{ 'payment.oneTime.access' | translate }}
          </div>
        </div>

        <!-- SUBSCRIPTION: annual / monthly selectable -->
        <div class="pw-card sub" *ngIf="!storeMode || storeProducts.monthly || storeProducts.annual">
          <div class="pw-kicker">{{ 'paywall.subKicker' | translate }}</div>
          <div class="pw-seg" role="tablist">
            <button
              type="button"
              class="pw-seg-btn"
              [class.active]="selectedBilling === 'annual'"
              (click)="setBilling('annual')"
            >
              {{ 'payment.subscription.annualLabel' | translate }}
            </button>
            <button
              type="button"
              class="pw-seg-btn"
              [class.active]="selectedBilling === 'monthly'"
              (click)="setBilling('monthly')"
            >
              {{ 'payment.subscription.monthlyLabel' | translate }}
            </button>
          </div>
          <div class="pw-price" *ngIf="subPrimary">
            {{ subPrimary }}
            <span class="pw-once">{{ subPerKey | translate }}</span>
          </div>
          <div class="pw-billing" *ngIf="selectedBilling === 'annual' && annualEquivalent">
            {{ annualEquivalent }}
          </div>
          <!-- Savings are computed from the two real prices (same platform, same
               currency) and rounded down; hidden when they cannot be trusted. -->
          <div class="pw-save" *ngIf="selectedBilling === 'annual' && annualSavePct">
            {{ 'payment.subscription.saveBadge' | translate: { pct: annualSavePct } }}
          </div>
          <ul class="pw-features">
            <li>{{ 'payment.subscription.feature1' | translate }}</li>
          </ul>
          <div class="pw-clarity">{{ subBillingKey | translate }}</div>
          <button
            type="button"
            class="pw-cta sub-cta"
            (click)="storeMode ? storeBuy(selectedBilling) : selectSubscription()"
            [disabled]="isProcessing"
          >
            {{
              processingPlanId === 'annual' || processingPlanId === 'monthly'
                ? ('payment.processing' | translate)
                : (subButtonKey | translate)
            }}
          </button>
        </div>
      </div>

      <!-- Store billing (native apps): messages, renewal terms, restore, legal links -->
      <div class="pw-store" *ngIf="storeMode && pricesLoaded">
        <p class="pw-store-msg" *ngIf="storeMessage" role="status">{{ storeMessage }}</p>
        <p class="pw-store-terms" *ngIf="storeProducts.monthly || storeProducts.annual">
          {{ 'payment.store.autoRenewNote' | translate: { store: storeName } }}
        </p>
        <button
          type="button"
          class="pw-store-restore"
          (click)="storeRestore()"
          [disabled]="isProcessing"
        >
          {{ (restoring ? 'payment.store.restoring' : 'payment.store.restore') | translate }}
        </button>
        <div class="pw-store-links">
          <a [href]="brandService.config.termsOfUseUrl" target="_blank" rel="noopener">{{ 'payment.store.terms' | translate }}</a>
          <span aria-hidden="true">·</span>
          <a [href]="brandService.config.privacyPolicyUrl" target="_blank" rel="noopener">{{ 'payment.store.privacy' | translate }}</a>
        </div>
      </div>

      <p class="pw-footnote">{{ 'paywall.footnote' | translate }}</p>

      <!-- Variant B: dignified exit back to the free initial review -->
      <a
        *ngIf="variant === 'B'"
        class="pw-exit"
        role="button"
        tabindex="0"
        (click)="dismiss()"
        (keydown.enter)="dismiss()"
      >
        {{ 'paywall.exitLink' | translate }}
      </a>
    </div>
  </div>
</div>
